import { Search, X } from 'lucide-react';
import { useRef, useState } from 'react';
import { motion } from 'framer-motion';

interface SearchBarProps {
  value: string;
  placeholder?: string;
  onChange: (value: string) => void;
  onClear?: () => void;
}

const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    padding: '10px 14px',
    background: '#27272a',
    border: '1px solid #3f3f46',
    borderRadius: '12px',
    transition: 'all 0.2s ease',
  },
  icon: {
    color: '#71717a',
    flexShrink: 0,
  },
  input: {
    flex: 1,
    background: 'transparent',
    border: 'none',
    outline: 'none',
    color: '#fafafa',
    fontSize: '14px',
    padding: 0,
  },
  clearBtn: {
    background: 'none',
    border: 'none',
    color: '#71717a',
    cursor: 'pointer',
    padding: '4px',
    borderRadius: '6px',
    display: 'flex',
    alignItems: 'center',
    transition: 'all 0.15s',
    flexShrink: 0,
  },
};

export default function SearchBar({ value, placeholder = 'Tìm kiếm...', onChange, onClear }: SearchBarProps) {
  const inputRef = useRef<HTMLInputElement>(null);
  const [isFocused, setIsFocused] = useState(false);

  return (
    <motion.div
      style={{
        ...styles.container,
        borderColor: isFocused ? '#3b82f6' : '#3f3f46',
        boxShadow: isFocused 
          ? '0 0 0 3px rgba(59, 130, 246, 0.2), 0 4px 12px rgba(0, 0, 0, 0.5)' 
          : '0 1px 2px rgba(0, 0, 0, 0.4)',
      }}
      animate={{
        borderColor: isFocused ? '#3b82f6' : '#3f3f46',
        boxShadow: isFocused 
          ? '0 0 0 3px rgba(59, 130, 246, 0.2), 0 4px 12px rgba(0, 0, 0, 0.5)' 
          : '0 1px 2px rgba(0, 0, 0, 0.4)',
      }}
      transition={{ duration: 0.2 }}
    >
      <motion.div
        style={styles.icon}
        animate={{ color: isFocused ? '#3b82f6' : '#71717a' }}
        transition={{ duration: 0.2 }}
      >
        <Search size={18} />
      </motion.div>
      
      <input
        ref={inputRef}
        type="text"
        style={styles.input}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
      />
      
      {value && (
        <motion.button
          style={styles.clearBtn}
          onClick={onClear}
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.8 }}
          whileHover={{ 
            scale: 1.1,
            color: '#fafafa',
            background: '#3f3f46',
          }}
          whileTap={{ scale: 0.9 }}
          transition={{ duration: 0.15 }}
        >
          <X size={16} />
        </motion.button>
      )}
    </motion.div>
  );
}
